import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import moment from 'moment';
import { DISPLAY_TIME_FORMATS, TimePrecision } from '@bazis/form/models/form-element.types';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'bazis-timeinterval',
    templateUrl: './timeinterval.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisTimeintervalComponent implements OnInit {
    @Input() precision: TimePrecision = 'minutes';

    @Input() delimiter: string = '';

    @Input() value: Date[] = null;

    @Output() valueChange = new EventEmitter();

    displayFormat: string = '';

    textValues = ['', ''];

    from: Date;

    to: Date;

    ngOnInit() {
        this.displayFormat = DISPLAY_TIME_FORMATS[this.precision];
        this.from = this.value && this.value[0] ? this.value[0] : null;
        this.to = this.value && this.value[1] ? this.value[1] : null;

        this.textValues = [
            this.from ? moment(this.from).format(this.displayFormat) : '',
            this.to ? moment(this.to).format(this.displayFormat) : '',
        ];
    }

    setValue(e, index: number) {
        this.textValues[index] = e;
        this.valueChange.emit(this.textValues.join(this.delimiter));
    }
}
